






















import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Helpers
 */
import { sortByAsc } from "@/utils/sort-helpers";
import { addMinutes } from '@/utils/date-helpers';

/**
 * Components
 */
import BookingCalendar from "./components/BookingCalendar.vue";

/**
 * API
 */
import bookingsAPI, { ResourceBookableTimeRange, ResourceBooking, BookingCategory } from "@/api/bookings";
import usersAPI from "@/api/users";
import servicesAPI, { ModePassage } from "@/api/services";


/**
 * Page de réservation horaires.
 */
@Component({
	components: { BookingCalendar }
})
export default class BookingResourcesPage extends Vue {
	$refs!: {
		calendar: BookingCalendar
	};

	isLoading = false;
	isActionLoading = false;

	@Action('openInfo', { namespace: 'snackbar' })
	openInfo: any;
	@Action('openError', { namespace: 'snackbar' })
	openError: any;

	// Les usagers possibles
	users: any[] = [];

	// Les services possibles
	services: any[] = [];


	async created() {
		this.isLoading = true;
		await this.loadFilterDefinitionsData();
		this.isLoading = false;
	}

	async loadFilterDefinitionsData() {
		const currentUser = await usersAPI.getCurrent();
		const currentUserChildren = await usersAPI.getChildrenForBooking();

		const services = await servicesAPI.getAll(ModePassage.RESOURCES);
		this.users = [
			currentUser,
			...currentUserChildren
		];

		this.services = services.sort(sortByAsc((x) => x.label));
	}


	async fetchDayBookableTimeRanges(day: number, month: number, year: number): Promise<ResourceBookableTimeRange[]> {
		return await bookingsAPI.getAllowedDayBookableTimeRanges(day, month, year);
	}

	// Doit retourner MES réservations ET celles des autres
	async fetchDayBookings(day: number, month: number, year: number): Promise<any[]> {
		const bookings = await bookingsAPI.getAll(year, month, day, BookingCategory.RESOURCES, true);
		return bookings.map((b) => ({
			startDate: new Date(Date.parse(b.bookedDate)),
			durationInMinutes: b.actualDurationInMinutes,
			service: b.service,
			user: b.user,
			state: b.state,
			isEditable: b.isEditable,
			isReadable: b.isReadable
		}));
	}
}
